// Adapted from tutorialzine implementation here:
// https://tutorialzine.com/2017/08/image-zoom-library-with-vanilla-javascript

export default class Zoom {
  DURATION = 120;

  /**
  * @param {import('../ThemeBase').default} theme
  * @param {HTMLElement} element
  */

  constructor(theme, element) {
    this.element = element;
    this.timer = null;
    this.imgEl = this.element.querySelector('img');
    this.zoomedImage = /** @type {HTMLDivElement} */ (this.element.querySelector('.zoomed-image'));
    this.zoomedImg = document.createElement('img');

    this.init();
  }

  init = () => {
    var self = this;

    if (!this.element) {
      console.error('No container element. Please make sure you are using the right markup.');
      return;
    }

    if (!this.zoomedImage) {
      console.error('No zoomed image element. Please make sure you are using the right markup.');
      return;
    }

    if (!this.imgEl) {
      console.error('No preview images on page. Please make sure you are using the right markup.');
      return;
    } else {
      // Set the source of the zoomed image.
      this.zoomedImage.style.backgroundImage = `url(https:${this.imgEl.getAttribute('data-zoom-img')} )`;
      this.zoomedImg.src = `https:${this.imgEl.getAttribute('data-zoom-img')}`;
    }

    // Change the selected image to be zoomed when clicking on the previews.
    this.element.addEventListener("click", function (event) {
      var elem = /** @type {HTMLImageElement} */ (event.target);

      if (elem.classList.contains("product-single__thumbnail__image")) {
        var imageSrc = elem.src;
        self.zoomedImage.style.backgroundImage = 'url(' + imageSrc + ')';
      }
    });

    // Zoom image on mouse enter.
    this.element.addEventListener('mouseenter', function (e) {
      // Hide zoomed image when it's smaller then parent div,
      // it would just move but there won't be any zoom
      if (self.element.clientWidth >= self.zoomedImg.naturalWidth) {
        if (self.zoomedImage.classList.contains('hide')) return;

        self.zoomedImage.classList.add('hide');
        return;
      } else {
        self.zoomedImage.classList.remove('hide');
      }

      // Hide image when zoomed image is hovered - to prevent
      // both images visible when the image is too small
      self.timer = setTimeout(() => {
        self.imgEl.classList.add('product-image-hidden');
        self.timer = null;
      }, self.DURATION);

      self.zoomedImage.style.backgroundSize = `${self.zoomedImg.naturalWidth}px, ${self.zoomedImg.naturalHeight}px`;
    }, false);

    // Show different parts of image depending on cursor position.
    this.zoomedImage.addEventListener('mousemove', function (e) {
      // getBoundingClientReact gives us various information about the position of the element.
      var dimentions = this.getBoundingClientRect();

      // Calculate the position of the cursor inside the element (in pixels).
      var x = e.clientX - dimentions.left;
      var y = e.clientY - dimentions.top;

      // Calculate the position of the cursor as a percentage of the total width/height of the element.
      var xpercent = Math.round(100 / (dimentions.width / x));
      var ypercent = Math.round(100 / (dimentions.height / y));

      // Update the background position of the image.
      this.style.backgroundPosition = xpercent + '% ' + ypercent + '%';
    }, false);


    // When leaving the container zoom out the image back to normal size.
    this.zoomedImage.addEventListener('mouseleave', function (e) {
      this.style.backgroundSize = "cover";
      this.style.backgroundPosition = "center";

      if (self.zoomedImage.classList.contains('hide')) return;
      self.zoomedImage.classList.add('hide');

      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.imgEl.classList.remove('product-image-hidden');
    }, false);

  }
}
